<template>
    <!--Section Two-->
      <v-container style="padding-top:5vh; padding-bottom:5vh;" id="programs">
        <v-row justify="center" align="center" class="center">
          <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
            <p
              style="line-height:1.25"
              class="text-h4 text-sm-h4 text-md-h4 text-lg-h3 text-xl-h3 black--text font-weight-medium"
            >
              Programs
            </p>

            <p
              style="line-height:1.25"
              class="text-h5 text-sm-h5 text-md-h5 text-lg-h4 text-xl-h4  black--text font-weight-thin"
            >
              Choose from one of our pre-made programs or get in touch to build youw own!
            </p>
          </v-col>
        </v-row>

        <v-row justify="center" align="center">
          <v-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3" v-for="program in programs" :key="program.image">
            <v-card @click="scrollTo('contact')">
              <v-img :src="program.image" />
            </v-card>
          </v-col>
        </v-row>

      </v-container>
      <!--Section One-->
</template>


<script>
// @ is an alias to /src

export default {
  name: "Home",
  components: {
    //
  },
  data: () => ({
     programs:[
      {image:"img/programs/program-1.jpeg"},
      {image:"img/programs/program-2.jpeg"},
      {image:"img/programs/program-3.jpeg"},
      {image:"img/programs/program-4.jpeg"},
      {image:"img/programs/program-5.jpeg"},
      {image:"img/programs/program-6.jpeg"},
      {image:"img/programs/program-7.jpeg"},
      {image:"img/programs/program-8.jpeg"},

    ],
  }),
  methods: {
    //
  }
};
</script>



<style>
.workSansLight{
  font-family: 'Work Sans', sans-serif !important;font-weight:400;font-style: normal;
}

.workSans{
  font-family: 'Work Sans', sans-serif !important;font-weight:700;font-style: normal;
}

.playFair{
  font-family: 'Playfair Display', serif !important;font-weight:700; font-style:italic;
}


</style>
